"use client";

import React, { useEffect } from 'react'
import Login from './app/auth/Login'
import Register from './app/auth/register'
import { Route, BrowserRouter, Routes, useLocation } from 'react-router-dom'
import WebsiteLayout from './app/plateform/layout/WebsiteLayout'
import Formation from './app/plateform/pages/Formation'
import FindJob from './app/plateform/pages/FindJob'
import FindTalent from './app/plateform/pages/FindTalent2'
import Home from './app/plateform/pages/Home'
import JobDetail from './app/plateform/pages/FindJob/JobDetail'
import FindTrainers from './app/plateform/pages/FindTrainers'
import FindRecruiter from './app/plateform/pages/FindRecruiter'
import FormationDetail from './app/plateform/pages/Formation/FormationDetail'
import Request from './app/plateform/pages/Request'
import RecruiterDetail from './app/plateform/pages/FindRecruiter/RecruiterDetail';
import TrainerDetail from './app/plateform/pages/FindTrainers/TrainerDetail';
import TermesAndConditions from './app/plateform/pages/TermesAndConditions';
import Help from './app/plateform/pages/Help'
import Plans from './app/plateform/pages/Plans'

import CandidateLayout from './app/plateform/candidate/Layout';
import CandidatHome from "./app/plateform/candidate/pages/Home"
import ForgotPassword from "./app/auth/ForgotPassword"
import Applications from './app/plateform/candidate/pages/Applications'
import Resume from './app/plateform/candidate/pages/Resume'
import Parameter from './app/plateform/candidate/pages/Parameter';
import Enrollments from "./app/plateform/candidate/pages/Enrollments"

// recruiter routes
import EditOffer from "./app/plateform/recruiter/pages/Recruitment/Edit"
import RecruitementDetail from "./app/plateform/recruiter/pages/Recruitment/Enrollments"
import RecruiterLayout from './app/plateform/recruiter/Layout';
import RecruiterHome from './app/plateform/recruiter/pages/Home';
import Recruitment from './app/plateform/recruiter/pages/Recruitment'
// import RecruiterApplication from './app/plateform/recruiter/pages/Applications';
// import Application from './app/plateform/recruiter/pages/Offer/Application'
// import OfferDetail from './app/plateform/recruiter/pages/Offer/OfferDetail'
import PostJob from './app/plateform/recruiter/pages/PostJob'
import RecruiterParameter from "./app/plateform/recruiter/pages/Parameter"
import RecruiterCandidate from './app/plateform/recruiter/pages/Offer/Candidate';
import SavedCandidates from './app/plateform/recruiter/pages/SavedCandidates'
import Abonnement from './app/plateform/recruiter/pages/Abonnement';

import PageNotFound from "./app/plateform/pages/PageNotFound"
import ContactUs from "./app/plateform/pages/ContactUs"
import TrainerLayout from "./app/plateform/trainer/Layout"
import TrainerHome from "./app/plateform/trainer/pages/Home"
import PostTraining from './app/plateform/trainer/pages/PostTraining'
import Trainings from "./app/plateform/trainer/pages/Trainings"
import TrainerParameter from "./app/plateform/trainer/pages/Parameter"
import Students from './app/plateform/trainer/pages/Students'
import AboutTraining from './app/plateform/trainer/pages/Trainings/Enrollments/partials/About'
import Enrollement from './app/plateform/trainer/pages/Trainings/Enrollments/partials/Enrollement'

import TrainerEnrollements from './app/plateform/trainer/pages/Trainings/Enrollments'
import EditTraining from "./app/plateform/trainer/pages/Trainings/Edit"
import TestResume from './app/plateform/pages/TestResume'

// ADMIN ROUTES
import DashboardAdmin from './app/admin/page/Dashboard'
import Client from './app/admin/page/Client'
import DetailsClient from './app/admin/page/Client/Details'
import UpdateClient from './app/admin/page/Client/Update'
import ClientPro from './app/admin/page/ClientPro'
import DetailsClientPro from './app/admin/page/ClientPro/details'
import UpdateClientPro from './app/admin/page/ClientPro/Update'
import NewClientPro from './app/admin/page/ClientPro/New'
import AbonnementA from './app/admin/page/ClientPro/Abonnement'
import AbonnementAdmin from './app/admin/page/ClientPro/Abonnement'
import ProfileAdmin from './app/admin/page/Profile'
import ChangePassword from './app/admin/page/Profile/Generale/ChangePassword'
import ChangeEmail from './app/admin/page/Profile/Generale/ChangeEmail'
import VerificationEmail from './app/admin/page/Profile/Generale/VerificationEmail'
import UpdateProfile from './app/admin/page/Profile/Generale/UpdateProfile'
import NewClient from './app/admin/page/Client/New'
import ServiceAdmin from './app/admin/page/ClientPro/ServiceAdmin'
import DetailsAbonnement from './app/admin/page/ClientPro/Abonnement/Details'
import Notification from './app/admin/page/Notification'
import Offre from './app/admin/page/ClientPro/ServiceAdmin/Offre'
import DetailsService from './app/admin/page/ClientPro/ServiceAdmin/Details'
import Administrateur from './app/admin/page/Administrateur'
import NewAdministrateur from './app/admin/page/Administrateur/New'
import DetailsAdministrateur from './app/admin/page/Administrateur/Details'
import UpdateAdministrateur from './app/admin/page/Administrateur/Update'
import Categorie from './app/admin/page/Categorie'
import NewCategorie from './app/admin/page/Categorie/New'
import UpdateCategorie from './app/admin/page/Categorie/Update'
import UpdateService from './app/admin/page/ClientPro/ServiceAdmin/Update'
import LayoutAdmin from './app/admin/Layout'
import AddOffre from './app/admin/page/ClientPro/ServiceAdmin/Offre/add'
import ApplicationDetail from './app/plateform/recruiter/pages/Recruitment/Enrollments/ApplicationDetail'

import StudentDetail from "./app/plateform/trainer/pages/Students/StudentDetail"

// import { LayoutSecurity } from './website/layout/LayoutSecurity'
// import ContactUs from "./website/pages/Contactus"
// import ParentComponent from './website/pages/ParentComponent'

 const Routers = () => {
  // const  {pathname} = useLocation()

  // useEffect(() => {
  //   window.scrollTo(0, 0)
 
  // }, [pathname])

  return (
    <BrowserRouter>
    <Routes>
    
        <Route path='/' element={<WebsiteLayout/>} >
            <Route index element={<Home/>}/>
            {/* <Route path='home' element={<AdminHome/>}/> */}
            <Route path="/offre" element={<FindJob/>} />
            <Route path='/offre/:id' element={<JobDetail/>}/>

            <Route path="/formation" element={<Formation/>} />
            <Route path="/formation/:id" element={<FormationDetail/>} />
 
            <Route path='/candidat' element={<FindTalent/>}/>
            {/* <Route path='/candidat/:id' element={<CandidateDetail/>}/> */}

            <Route path='/recruteur' element={<FindRecruiter/>}/>
            <Route path='/recruteur/:id' element={<RecruiterDetail/>}/>

            <Route path='/formateur' element={<FindTrainers/>}/>
            <Route path='/formateur/:id' element={<TrainerDetail/>}/>
            
            <Route path='/requete' element={<Request/>}/>
            <Route path='/requete/:id' element={<Request/>}/>

            <Route path='/termes-et-conditions' element={<TermesAndConditions/>}></Route>
             <Route path='/aide' element={<Help/>}></Route>
             <Route path='plans' element={<Plans/>}></Route>
             <Route path="contact" element={<ContactUs/>} />
             <Route path="*" element={<PageNotFound/>} />
        </Route>

        {/* <Route path='/candidat' element={<CandidateLayout/>} >
          <Route index element={<CandidatHome/>}/>
          <Route path='candidature' element={<Applications/>}/>
          <Route path='cv' element={<Resume/>}/>
          <Route path='enregistrement' element={<Enrollments/>}></Route>
          <Route path='parametre' element={<Parameter/>}></Route>
        </Route> */}

        <Route path='/mira-lenta' element={<CandidateLayout/>} >
          <Route index element={<CandidatHome/>} />
          <Route path='candidature' element={<Applications/>} />
          <Route path='cv' element={<Resume/>} />
          <Route path='enregistrement' element={<Enrollments/>} />
          <Route path='parametre' element={<Parameter/>} />
        </Route>
        
        <Route path='/mira-recruteur' element={<RecruiterLayout/>} >
          <Route index element={<RecruiterHome/>}/>
          <Route path='offre' element={<Recruitment/>}/>
          {/* <Route path='offre/:id' element={<OfferDetail/>}/>
          <Route path='offre/:id/modif' element={<Recruitment/>}/>
          <Route path='offre/:id/application' element={<RecruiterCandidate/>}/> */}

{/* <Route path='offre/:id' element={<OfferDetail/>}/> */}
          <Route path='offre/:id/modifier' element={<EditOffer/>}/>
          <Route path='offre/:id/candidature/:opt' element={<RecruitementDetail/>}/>
          <Route path='offre/candidature/:application_id' element={<ApplicationDetail/>}/>
          <Route path='abonnement' element={<Abonnement/>}/>
          <Route path='offre/nouveau' element={<PostJob/>}/>
          <Route path='candidat' element={<SavedCandidates/>}></Route>
          <Route path='parametre' element={<RecruiterParameter/>}></Route>
        </Route>

        <Route path='/mira-formateur' element={<TrainerLayout/>}>
          <Route index element={<TrainerHome/>}/>
          <Route path='formation' element={<Trainings/>}/>
          <Route path='etudiant' element={<Students/>}/>
          <Route path='etudiant/:id' element={<StudentDetail/>}/>
          <Route path='formation/:id/modifier' element={<EditTraining/>}/>
          <Route path='abonnement' element={<Abonnement/>}/>
          <Route path='formation/nouveau' element={<PostTraining/>}/>
          <Route path='formation/:id/inscription/:opt' element={<TrainerEnrollements/>}/>
          <Route path='formation/:id' element={<AboutTraining/>}/>
          <Route path='formation/:id/inscription' element={<Enrollement/>}/>
          <Route path='parametre' element={<TrainerParameter/>}/>
        </Route>

        // interface admin

        <Route path='/admin' element={<LayoutAdmin />}>
          <Route index element={<DashboardAdmin />} />

          {/* CLIENT ROUTE */}
          <Route path="client" element={<Client />} />
          <Route path="nouveauClient" element={<NewClient />} />
          <Route path="detailsClient/:id" element={<DetailsClient />} />
          <Route path="modificationClient/:id" element={<UpdateClient />} />

          {/* CLIENT PRO ROUTE */}
          <Route path="prestataire" element={<ClientPro />} />
          <Route path="nouveauPrestataire" element={<NewClientPro />} />
          <Route path="detailsPrestataire/:id" element={<DetailsClientPro />} />
          <Route path="modificationPrestataire/:id" element={<UpdateClientPro />} />

          {/* ADMINISTRATEUR ROUTE */}
          <Route path="administrateur" element={<Administrateur />} />
          <Route path="nouveauAdministrateur" element={<NewAdministrateur />} />
          <Route path="detailsAdministrateur/:id" element={<DetailsAdministrateur />} />
          <Route path="modificationAdministrateur/:id" element={<UpdateAdministrateur />} />

          {/* ABONNEMENT ROUTE */}
          <Route path="abonnement/:id" element={<AbonnementA />} />

          {/* ABONNEMENT ROUTE */}
          <Route path="abonnement/:id" element={<AbonnementAdmin />} />

          <Route path="detailsAbonnement/:id" element={<DetailsAbonnement />} />

          {/* SERVICE ROUTE */}
          <Route path="service/:id" element={<ServiceAdmin />} />
          <Route path="detailsService/:id" element={<DetailsService />} />
          <Route path="modificationService/:id" element={<UpdateService />} />
          {/* <Route path="nouveauService" element={<NewService />} /> */}
          <Route path="offre/:id" element={<Offre />} />
          <Route path="addOffre/:id" element={<AddOffre />} />

          {/* CATEGORIE ROUTE */}
          <Route path="secteur" element={<Categorie />} />
          <Route path="nouveauSecteur" element={<NewCategorie />} />
          <Route path="modificationSecteur/:id" element={<UpdateCategorie />} />

          {/* PROFILE ROUTE  */}

          <Route path="profile" element={<ProfileAdmin />} />
          <Route path="changePassword" element={<ChangePassword />} />
          <Route path="changeEmail" element={<ChangeEmail />} />
          <Route path="verificationEmail/:email" element={<VerificationEmail />} />
          <Route path="modificationProfile" element={<UpdateProfile />} />
          <Route path="notification" element={<Notification />} />
        </Route>

        <Route path="/login" element={<Login/>} />
        <Route path="*" element={<PageNotFound/>} />
        <Route path="/forgotPassword" element={<ForgotPassword/>} />
        <Route path="/register" element={<Register/>} />  
        <Route path='test' element={<TestResume></TestResume>}></Route>
    </Routes>
  </BrowserRouter>
  )
}

export default Routers
